module.exports = __webpack_public_path__ + "img/horizontal_6_5_8019.af239a9f.png";